import {createFileRoute} from '@tanstack/react-router'
import EmbedTournamentWidget from '../../embed/EmbedTournamentWidget'
import services from '../../services'
import {config} from '../../config/config'
import {humanizeSlug} from '../../utilities'

// Public, chrome-less tournament widget for embedding on an organizer's own website. Framed by an
// <iframe> (or injected by /embed.js). No auth, no app nav — just the widget.
export const Route = createFileRoute('/embed/tournaments/$uid')({
    component: EmbedTournamentWidget,
    validateSearch: (search: Record<string, unknown>): {show?: string; theme?: 'light' | 'dark'; division?: string} => ({
        show:     typeof search.show === 'string' ? search.show : undefined,
        theme:    search.theme === 'dark' ? 'dark' : 'light',
        division: typeof search.division === 'string' ? search.division : undefined,
    }),
    loader: async ({params}) => {
        try {
            const t = await services.tournaments.find(params.uid)
            return {event: t && (t as any).uid ? t : null}
        } catch {
            return {event: null}
        }
    },
    head: ({loaderData, params}) => {
        const e: any = (loaderData as any)?.event
        const name = e?.title || humanizeSlug(params.uid)
        return {
            meta: [
                {title: `${name} | ScorePal`},
                {name: 'robots', content: 'noindex'},
            ],
            links: [{rel: 'canonical', href: `${config.publicUrl}/live/tournaments/${e?.slug || params.uid}/`}],
        }
    },
})
